import { Link } from "react-router-dom";
import { Crown, Phone, Mail, MapPin, ShieldCheck } from "lucide-react";

const AREAS = ["Mansfield", "Mansfield Woodhouse", "Kirkby-in-Ashfield", "Hucknall", "Nottingham", "Beeston", "Wollaton", "Ravenshead"];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-emerald-950 text-emerald-100/80">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-1">
        <div className="flex items-center gap-2.5 mb-4">
          <span className="grid place-items-center w-10 h-10 rounded-md bg-white/10">
            <Crown className="w-5 h-5" style={{ color: "#C59B27" }} />
          </span>
          <span className="font-serif text-lg text-white">Emerald Crown</span>
        </div>
        <p className="text-sm leading-relaxed text-emerald-100/70">
          Local Nottinghamshire property investors restoring tired and dated homes, and building long-term relationships with agents and vendors.
        </p>
      </div>

      <div>
        <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-brass mb-4">Explore</h4>
        <ul className="space-y-2.5 text-sm">
          <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
          <li><Link to="/projects" className="hover:text-white transition-colors">Recent Projects</Link></li>
          <li><Link to="/investment" className="hover:text-white transition-colors">Property Investment</Link></li>
          <li><Link to="/opportunities" className="hover:text-white transition-colors">Investor Opportunities</Link></li>
          <li><Link to="/sell" className="hover:text-white transition-colors">Sell Your Property</Link></li>
          <li><Link to="/estate-agents" className="hover:text-white transition-colors">For Estate Agents</Link></li>
          <li><Link to="/resources" className="hover:text-white transition-colors">Free Resources</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-brass mb-4">Contact</h4>
        <ul className="space-y-2.5 text-sm">
          <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-brass" /><a href="tel:+447897674550" className="hover:text-white">07897 674550</a></li>
          <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-brass" /><a href="mailto:hello@emeraldcrown.co.uk" className="hover:text-white">hello@emeraldcrown.co.uk</a></li>
          <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-brass mt-0.5" /><span>Nottinghamshire, UK</span></li>
        </ul>
      </div>

      <div>
        <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-brass mb-4">Areas We Cover</h4>
        <div className="flex flex-wrap gap-1.5">
          {AREAS.map((a) => (
            <span key={a} className="text-[11px] px-2 py-1 rounded-full bg-white/5 border border-white/10">{a}</span>
          ))}
        </div>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-testid="footer-redress-badge">
        <div className="flex items-center gap-3 rounded-xl border border-brass/30 bg-white/5 px-4 py-3 w-fit">
          <span className="grid place-items-center w-9 h-9 rounded-lg bg-brass/15 shrink-0"><ShieldCheck className="w-5 h-5 text-brass" /></span>
          <div>
            <div className="text-sm font-medium text-white">Proud to be part of the Property Redress Scheme</div>
            <div className="text-xs text-emerald-100/60">Giving vendors and agents confidence they're dealing with a professional, accountable buyer.</div>
          </div>
        </div>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-emerald-100/60">
        <p>© {new Date().getFullYear()} Emerald Crown Property Investments. All rights reserved.</p>
        <div className="flex items-center gap-4">
          <Link to="/privacy-policy" className="hover:text-white" data-testid="footer-privacy-policy-link">Privacy Policy</Link>
          <Link to="/admin/login" className="hover:text-white opacity-60" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </div>
  </footer>
);
